@if (isEmulating()) {
  <!-- Ambient frame: a colored border around the whole viewport. Edges only, so it never covers
       navigation or content. -->
  <div class="emulation-frame" aria-hidden="true"></div>

  <!-- Compact status pill, bottom-right, out of the way of the left nav and page content. -->
  <div class="emulation-pill" role="status" aria-live="polite">
    <mat-icon class="emulation-pill__icon" aria-hidden="true">visibility</mat-icon>
    <span class="emulation-pill__text">
      Emulating <strong>{{ profile()?.fullName }}</strong>
      @if (profile()?.organizationName) {
        <span class="emulation-pill__org">· {{ profile()?.organizationName }}</span>
      }
      <span class="emulation-pill__mode">· read-only</span>
    </span>
    <button
      mat-flat-button
      class="emulation-pill__exit"
      type="button"
      (click)="exitEmulation()"
    >
      Exit
    </button>
  </div>
}
